import { LastActiveFilterEnum, SalesStatusEnum } from "../../../enum";
import { ActivityRecencyTier } from "../../../util/util";

interface SalesStatusMeta {
  label: string;
  badgeColor: string;
  textColor: string;
  dotColor: string;
}

export const salesStatusMeta: Record<SalesStatusEnum, SalesStatusMeta> = {
  [SalesStatusEnum.NotContacted]: {
    label: "Not Contacted",
    badgeColor: "#f0f0f0",
    textColor: "#666666",
    dotColor: "#999999",
  },
  [SalesStatusEnum.Contacted]: {
    label: "Contacted",
    badgeColor: "#d1ecf1",
    textColor: "#0c5460",
    dotColor: "#4a90e2",
  },
  [SalesStatusEnum.FollowUpScheduled]: {
    label: "Follow-up Scheduled",
    badgeColor: "#fff3cd",
    textColor: "#856404",
    dotColor: "#fa8c16",
  },
  [SalesStatusEnum.Converted]: {
    label: "Converted",
    badgeColor: "#d4edda",
    textColor: "#155724",
    dotColor: "#52c41a",
  },
  [SalesStatusEnum.NotInterested]: {
    label: "Not Interested",
    badgeColor: "#f8d7da",
    textColor: "#721c24",
    dotColor: "#ff4d4f",
  },
  [SalesStatusEnum.Unreachable]: {
    label: "Unreachable",
    badgeColor: "#eeeeee",
    textColor: "#8c8c8c",
    dotColor: "#bfbfbf",
  },
};

export const salesStatusOptionList = Object.values(SalesStatusEnum).map(
  (status) => ({ value: status, label: salesStatusMeta[status].label })
);

const lastActiveLabel: Record<LastActiveFilterEnum, string> = {
  [LastActiveFilterEnum.Today]: "Active Today",
  [LastActiveFilterEnum.Week]: "Active This Week",
  [LastActiveFilterEnum.Month]: "Active This Month",
  [LastActiveFilterEnum.Inactive30Plus]: "Inactive 30+ Days",
  [LastActiveFilterEnum.Never]: "Never Active",
};

export const lastActiveOptionList = Object.values(LastActiveFilterEnum).map(
  (option) => ({ value: option, label: lastActiveLabel[option] })
);
export const activityRecencyStripeColor: Record<ActivityRecencyTier, string> = {
  today: "#52c41a",
  week: "#faad14",
  month: "#fa8c16",
  stale: "#ff4d4f",
};
